import axios from 'axios'
import fn from '../../utils/functions'

function initSession () {
  const session = {
    queryParams: {
      closeDateTimeFrom: fn.initDateFrom(3),
      closeDateTimeTo: fn.initDateTo()
    }
  }
  return session
}
// state
const state = {
  local: {
    // Columnas Tabla
    accountingCloseTableProjectNameShown: true,
    accountingCloseTableBuyerNameShown: true,
    accountingCloseTableNameShown: true,
    accountingCloseTableCloseDateTimeShown: true,
    accountingCloseTableStatusShown: true,
    accountingCloseTableStartDateShown: true,
    accountingCloseTableEndDateShown: true,
    accountingCloseTableChildAccountingCloseNameShown: true
  },
  session: initSession()
}

// getters
const getters = {
  getCierresContablesQueryParams: state => {
    return state.session.queryParams
  },

  // Columnas
  isAccountingCloseTableProjectNameShown: state => {
    return state.local.accountingCloseTableProjectNameShown
  },
  isAccountingCloseTableBuyerNameShown: state => {
    return state.local.accountingCloseTableBuyerNameShown
  },
  isAccountingCloseTableNameShown: state => {
    return state.local.accountingCloseTableNameShown
  },
  isAccountingCloseTableCloseDateTimeShown: state => {
    return state.local.accountingCloseTableCloseDateTimeShown
  },
  isAccountingCloseTableStatusShown: state => {
    return state.local.accountingCloseTableStatusShown
  },
  isAccountingCloseTableStartDateShown: state => {
    return state.local.accountingCloseTableStartDateShown
  },
  isAccountingCloseTableEndDateShown: state => {
    return state.local.accountingCloseTableEndDateShown
  },
  isAccountingCloseTableChildAccountingCloseNameShown: state => {
    return state.local.accountingCloseTableChildAccountingCloseNameShown
  }
}

// actions
const actions = {
  isNewVersionCierresContablesLocalState ({ state }, localStorage) {
    return fn.isNewVersion(state, localStorage.cierrescontables)
  },
  async getAccountingCloses ({ commit, rootState }, queryParams) {
    try {
      queryParams.urlName = null
      if (rootState.session.urlIn !== null && rootState.session.urlIn !== undefined &&
        rootState.session.urlIn !== 'b2b') {
        queryParams.urlName = rootState.session.urlIn
      }
      commit('CIERRES_CONTABLES_QUERYPARAMS', queryParams)
      const response = await axios({
        method: 'GET',
        url: '/accountingclose',
        params: queryParams
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('getUsers: ', error.response)
      throw error.response
    }
  },
  async verifyAccountinClose ({ commit, rootState }, queryParams) {
    try {
      queryParams.urlName = null
      if (rootState.session.urlIn !== null && rootState.session.urlIn !== undefined &&
        rootState.session.urlIn !== 'b2b') {
        queryParams.urlName = rootState.session.urlIn
      }
      const response = await axios({
        method: 'GET',
        url: '/accountingclose/' + queryParams.id + '/signatureverification',
        params: queryParams
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('getUsers: ', error.response)
      throw error.response
    }
  },
  async closeAccountinClose ({ commit, rootState }, queryParams) {
    try {
      queryParams.urlName = null
      if (rootState.session.urlIn !== null && rootState.session.urlIn !== undefined &&
        rootState.session.urlIn !== 'b2b') {
        queryParams.urlName = rootState.session.urlIn
      }
      const response = await axios({
        method: 'GET',
        url: '/accountingclose/' + queryParams.id + '/closeAccounting',
        params: queryParams
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('getUsers: ', error.response)
      throw error.response
    }
  },

  setAccountingCloseTableProjectNameShown ({ commit }, newValue) {
    commit('CIERRES_CONTABLES_setAccountingCloseTableProjectNameShown', newValue)
  },

  setAccountingCloseTableBuyerNameShown ({ commit }, newValue) {
    commit('CIERRES_CONTABLES_setAccountingCloseTableBuyerNameShown', newValue)
  },

  setAccountingCloseTableNameShown ({ commit }, newValue) {
    commit('CIERRES_CONTABLES_setAccountingCloseTableNameShown', newValue)
  },

  setAccountingCloseTableCloseDateTimeShown ({ commit }, newValue) {
    commit('CIERRES_CONTABLES_setAccountingCloseTableCloseDateTimeShown', newValue)
  },

  setAccountingCloseTableStatusShown ({ commit }, newValue) {
    commit('CIERRES_CONTABLES_setAccountingCloseTableStatusShown', newValue)
  },

  setAccountingCloseTableStartDateShown ({ commit }, newValue) {
    commit('CIERRES_CONTABLES_setAccountingCloseTableStartDateShown', newValue)
  },

  setAccountingCloseTableEndDateShown ({ commit }, newValue) {
    commit('CIERRES_CONTABLES_setAccountingCloseTableEndDateShown', newValue)
  },

  setAccountingCloseTableChildAccountingCloseNameShown ({ commit }, newValue) {
    commit('CIERRES_CONTABLES_setAccountingCloseTableChildAccountingCloseNameShown', newValue)
  }
}

// mutations
const mutations = {
  resetSessionCierresContables (state) {
    state.session = initSession()
  },
  // Funcion para definir el filtro rápido de fechas cuando se es superadmin
  accountingCloseDatesSuperAdmin (state) {
    state.session.queryParams.closeDateTimeFrom = fn.initDateFrom(1)
  },
  'CIERRES_CONTABLES_QUERYPARAMS' (state, payload) {
    state.session.queryParams = payload
  },

  'CIERRES_CONTABLES_setAccountingCloseTableProjectNameShown' (state, payload) {
    state.local.accountingCloseTableProjectNameShown = payload
  },

  'CIERRES_CONTABLES_setAccountingCloseTableBuyerNameShown' (state, payload) {
    state.local.accountingCloseTableBuyerNameShown = payload
  },

  'CIERRES_CONTABLES_setAccountingCloseTableNameShown' (state, payload) {
    state.local.accountingCloseTableNameShown = payload
  },

  'CIERRES_CONTABLES_setAccountingCloseTableCloseDateTimeShown' (state, payload) {
    state.local.accountingCloseTableCloseDateTimeShown = payload
  },

  'CIERRES_CONTABLES_setAccountingCloseTableStatusShown' (state, payload) {
    state.local.accountingCloseTableStatusShown = payload
  },

  'CIERRES_CONTABLES_setAccountingCloseTableStartDateShown' (state, payload) {
    state.local.accountingCloseTableStartDateShown = payload
  },

  'CIERRES_CONTABLES_setAccountingCloseTableEndDateShown' (state, payload) {
    state.local.accountingCloseTableEndDateShown = payload
  },

  'CIERRES_CONTABLES_setAccountingCloseTableChildAccountingCloseNameShown' (state, payload) {
    state.local.accountingCloseTableChildAccountingCloseNameShown = payload
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
